import script from "./[tab].vue?vue&type=script&setup=true&lang=ts"
export * from "./[tab].vue?vue&type=script&setup=true&lang=ts"

import "./[tab].vue?vue&type=style&index=0&id=4a919268&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a919268"]])

export default __exports__